
import api from '@/apis/api'
import Coupon from '@/components/Coupon.vue'
import { Coupon as CouponModel } from '@/models/Coupon'
import axios from 'axios'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { QrcodeStream } from 'vue-qrcode-reader'

@Component({
  components: { QrcodeStream, Coupon },
})
export default class Home extends Vue {
  code: string | null = ''

  qrDialog = false
  qrInited = false
  qrInitError: Error | null = null

  couponDialog = false
  coupon: CouponModel | null = null

  validatingCoupon = false

  @Watch('qrDialog')
  onQrDialogChange(value: boolean): void {
    if (value) {
      if (this.validatingCoupon) {
        this.$nextTick(() => (this.qrDialog = false))
      }
    } else {
      this.qrInited = false
      this.qrInitError = null
    }
  }

  @Watch('code')
  onCodeChange(value: string): void {
    const formattedCode = this.code?.replace(/[^A-Za-z0-9]/g, '')?.toUpperCase() ?? ''
    if (formattedCode !== value) {
      this.$nextTick(() => (this.code = formattedCode))
    }
  }

  async qrInit(x: Promise<unknown>): Promise<void> {
    try {
      await x
      this.qrInited = true
    } catch (e) {
      this.qrInitError = new Error(`${e}`)
    }
  }

  get formattedCode(): string {
    return this.code?.replace(/[^A-Za-z0-9]/g, '')?.toUpperCase() ?? ''
  }

  qrDecode(x: string): void {
    this.qrDialog = false
    this.code = x
    this.goToCoupon()
  }

  async goToCoupon(): Promise<void> {
    try {
      this.validatingCoupon = true
      const coupon = await api.getCoupon(this.formattedCode)
      this.code = ''
      this.coupon = coupon
      this.couponDialog = true
    } catch (e) {
      if (axios.isAxiosError(e) && e.response?.status === 404) {
        this.$store.dispatch('snackbar', {
          message: "We're sorry, this offer code entered has already been redeemed",
          isError: true,
        })
      } else {
        this.$store.dispatch('snackbar', { message: e, isError: true })
      }
    } finally {
      this.validatingCoupon = false
    }
  }
}
